export default __webpack_public_path__ + "media/images/copyright2-63c2c14b894135087e6a977273c31bd5.png";